import React from 'react';

const UserManager: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">User Management</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage CMS users and permissions
        </p>
      </div>

      <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-2xl">👥</span>
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          User Management Coming Soon
        </h3>
        <p className="text-gray-500">
          Create and manage user accounts with role-based permissions.
        </p>
      </div>
    </div>
  );
};

export default UserManager;
